import { ArgumentError } from '../utils/errors';

import { BaseAPIModel } from '@weezevent/weezjs-core';

export default class AttendeeRefundRequest extends BaseAPIModel {
    static listUrl({ organizationId }) {
        if (!organizationId) {
            throw new ArgumentError(`[Model][AttendeeRefundRequest][getAll] organizationId is mandatory`);
        }

        return `/ticket/organizations/${organizationId}/attendees/refund_request`;
    }
}
